import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:\\projects\\xena\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'App',
  data: function data() {
    return {
      langs: [{
        label: 'NL',
        value: 'nl-nl'
      }, {
        label: 'EN',
        value: 'en-us'
      }, {
        label: 'DE',
        value: 'de-de'
      }]
    };
  },
  mounted: function mounted() {
    console.log('APP MOUNTED'); // this.$q.loading.show({})
    // console.log('App.vue: onMounted ')

    if (this.$q.platform.is.cordova) {
      // document.addEventListener('deviceready', this.onDeviceReady, false)
      // document.addEventListener('offline', this.onOffline, false)
      // document.addEventListener('online', this.onOnline, false)
      // document.addEventListener('pause', this.onPause, false)
      document.addEventListener('resume', this.onResume, false); // document.addEventListener('menubutton', this.onMenuKeyDown, false)
      // document.addEventListener('backbutton', this.onBackKeyDown, false)
    }

    var locale = this.$q.localStorage.getItem('locale');

    if (this.user) {
      if (this.user.locale) {
        locale = this.user.locale; // this.$q.localStorage.set('locale', this.$i18n.locale)
      } else {
        this.$meteor.call('user.setLocale', locale, function (err) {
          if (err) {} else {}
        });
      }
    }

    this.$i18n.locale = locale; // if (locale) {
    //     this.$i18n.locale = locale
    //
    // }

    /* console.log('qeury', this.$route.query)
    console.log('lang MVD', this.$route.query.lang)
    let locale = this.$q.localStorage.getItem('locale')
    console.log('WW' + locale)
    if (locale) {
        this.$i18n.locale = locale
    } else {
        this.$i18n.locale = {
            label: 'NL',
            value: 'nl-nl'
        }
    } */
    // throw new Error('Sentry Error MVD')
  },
  computed: _objectSpread({}, mapState(['user'])),
  methods: {
    onResume: function onResume() {
      // console.log('App.vue: cordova:onResume ')
      this.$meteor.reconnect();
      this.$store.dispatch('content/loadContent');
    }
  }
};